import React from "react";
import { isMobile, isTablet } from "react-device-detect";
import { IsTenant } from "../../../utils/helper";
import MobileViewNavTenant from "../SideNav/MobileViewNavTenant";
import "./Footer.less";
const Year = new Date().getFullYear();
/**
 * Used to render Footer Component in Application
 * @returns Footer Component for all user except Tenant in case of Mobile Footer Navigation is Returned
 */
export default function Footer() {
  return (
    <>
      {/* Added logic for checking mobile view and if its tenant then render bottom navigation  */}
      <div
        className={
          IsTenant() === true && (isMobile || isTablet)
            ? "footer-wrapper-mobile"
            : "footer-wrapper"
        }
      >
        {IsTenant() === true && (isMobile || isTablet) ? (
          <>
            <MobileViewNavTenant />
          </>
        ) : (
          <>
            <div className={"footer-left-div"} />
            <div className={"footer-middle-div"}>
              {"© "}{Year}{" Stream Data Centers |"}{" "}
              <a
                href={"https://www.streamdatacenters.com/privacy-policy/"}
                style={{ color: "#FFFFFF", textDecoration: "none" }}
                target={"_blank"} rel={"noreferrer"}
              >
                {"Privacy Policy\r"}
              </a>
            </div>
            <div className={"footer-right-div"} />
          </>
        )}
      </div>
    </>
  );
}
